(() => {
  if (window.__alternixQuickBuyInitialised) return;
  window.__alternixQuickBuyInitialised = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let activeTrigger = null;
  let state = null;

  function createDrawer() {
    if (document.querySelector('[data-vss-quickbuy]')) return;

    const drawer = document.createElement('div');
    drawer.className = 'vss-quickbuy';
    drawer.hidden = true;
    drawer.setAttribute('data-vss-quickbuy', '');
    drawer.innerHTML = `
      <div class="vss-quickbuy__backdrop" data-vss-quickbuy-close></div>
      <section class="vss-quickbuy__panel" role="dialog" aria-modal="true" aria-labelledby="vss-quickbuy-title">
        <div class="vss-quickbuy__header">
          <img class="vss-quickbuy__image" data-vss-quickbuy-image alt="">
          <div class="vss-quickbuy__headcopy">
            <h2 class="vss-quickbuy__title" id="vss-quickbuy-title" data-vss-quickbuy-title></h2>
            <div class="vss-quickbuy__meta" data-vss-quickbuy-meta></div>
            <a class="vss-quickbuy__details-link" data-vss-quickbuy-details href="#">
              View product details
            </a>
          </div>
          <button type="button" class="vss-quickbuy__close" data-vss-quickbuy-close aria-label="Close quick buy">×</button>
        </div>
        <div class="vss-quickbuy__body">
          <div data-vss-quickbuy-body></div>
        </div>
        <div class="vss-quickbuy__footer">
          <div class="vss-quickbuy__summary">
            <span data-vss-quickbuy-summary></span>
            <strong data-vss-quickbuy-total></strong>
          </div>
          <button type="button" class="vss-quickbuy__submit" data-vss-quickbuy-submit>Add to basket</button>
        </div>
      </section>
    `;
    document.body.appendChild(drawer);
  }

  function getDrawer() {
    createDrawer();
    return document.querySelector('[data-vss-quickbuy]');
  }

  function parsePackOptions(raw, unit) {
    if (!raw) return [];
    return raw.split('|').map((item) => {
      const [quantity, total, each] = item.split('~');
      return {
        quantity: Number(quantity),
        total: Number(total),
        each: Number(each),
        unit
      };
    }).filter((item) => item.quantity && Number.isFinite(item.total) && Number.isFinite(item.each));
  }

  function money(value) {
    return `£${Number(value).toFixed(2)}`;
  }

  function optionLabel(quantity, unit) {
    return `${quantity} ${unit}${quantity === 1 ? '' : 's'}`;
  }

  function savingPercent(baseEach, each) {
    if (!baseEach || !each || each >= baseEach) return 0;
    return Math.round((1 - (each / baseEach)) * 100);
  }

  function renderPurchaseUI() {
    const drawer = getDrawer();
    const body = drawer.querySelector('[data-vss-quickbuy-body]');
    const summary = drawer.querySelector('[data-vss-quickbuy-summary]');
    const totalTarget = drawer.querySelector('[data-vss-quickbuy-total]');
    const submit = drawer.querySelector('[data-vss-quickbuy-submit]');

    if (state.isBulk) {
      const baseEach = state.options[0]?.each || 0;

      body.innerHTML = `
        <div class="vss-quickbuy__eyebrow">Buy more, save more</div>
        ${state.stockEnforced
          ? `<div class="vss-quickbuy__stock-note">${state.availableStock} currently available</div>`
          : ''
        }
        <div class="vss-quickbuy__options" data-vss-quickbuy-options></div>
      `;

      const optionsTarget = body.querySelector('[data-vss-quickbuy-options]');

      optionsTarget.innerHTML = state.options.map((option, index) => {
        const saving = savingPercent(baseEach, option.each);
        const unavailable = state.stockEnforced && option.quantity > state.availableStock;

        return `
          <button
            type="button"
            class="vss-quickbuy__option${index === state.selectedIndex ? ' is-selected' : ''}${unavailable ? ' is-unavailable' : ''}"
            data-vss-quickbuy-option="${index}"
            role="radio"
            aria-checked="${index === state.selectedIndex ? 'true' : 'false'}"
            ${unavailable ? 'disabled aria-disabled="true"' : ''}
          >
            <span class="vss-quickbuy__radio" aria-hidden="true"></span>
            <span class="vss-quickbuy__option-main">
              <span class="vss-quickbuy__option-title">${optionLabel(option.quantity, option.unit)}</span>
              <span class="vss-quickbuy__option-sub">
                ${money(option.each)} each
                ${saving ? `<span class="vss-quickbuy__saving"> · Save ${saving}%</span>` : ''}
              </span>
              ${unavailable ? `<span class="vss-quickbuy__option-stock">Only ${state.availableStock} available</span>` : ''}
            </span>
            <span class="vss-quickbuy__option-price">${money(option.total)}</span>
          </button>
        `;
      }).join('');

      const selected = state.options[state.selectedIndex];
      const unavailable = state.stockEnforced && selected.quantity > state.availableStock;

      summary.textContent = optionLabel(selected.quantity, selected.unit);
      totalTarget.textContent = money(selected.total);
      submit.disabled = unavailable;
      submit.textContent = unavailable ? 'Not enough stock' : 'Add to basket';
      return;
    }

    body.innerHTML = `
      <div class="vss-quickbuy__single-intro">
        <div>
          <div class="vss-quickbuy__eyebrow">Choose quantity</div>
          <div class="vss-quickbuy__single-price">
            <strong>${money(state.unitPrice)}</strong>
            <span>per item</span>
          </div>
        </div>
        ${state.stockEnforced && state.availableStock <= 10
          ? `<span class="vss-quickbuy__low-stock">Only ${state.availableStock} left</span>`
          : ''
        }
      </div>

      <div class="vss-quickbuy__single-control-card">
        <div class="vss-quickbuy__quantity-row">
          <div>
            <div class="vss-quickbuy__quantity-heading">Quantity</div>
            <div class="vss-quickbuy__quantity-hint">Choose how many you'd like</div>
          </div>

          <div class="vss-quickbuy__quantity-control" aria-label="Choose quantity">
            <button
              type="button"
              class="vss-quickbuy__quantity-button"
              data-vss-quickbuy-minus
              aria-label="Decrease quantity"
              ${state.quantity <= 1 ? 'disabled' : ''}
            >−</button>

            <span class="vss-quickbuy__quantity-value">${state.quantity}</span>

            <button
              type="button"
              class="vss-quickbuy__quantity-button"
              data-vss-quickbuy-plus
              aria-label="Increase quantity"
              ${state.stockEnforced && state.quantity >= state.availableStock ? 'disabled' : ''}
            >+</button>
          </div>
        </div>

        <div class="vss-quickbuy__single-total-row">
          <span>Total</span>
          <strong>${money(state.unitPrice * state.quantity)}</strong>
        </div>
      </div>

      ${state.stockEnforced
        ? `<div class="vss-quickbuy__quantity-note">${state.availableStock} currently available</div>`
        : ''
      }
    `;

    summary.textContent = `${state.quantity} item${state.quantity === 1 ? '' : 's'}`;
    totalTarget.textContent = money(state.unitPrice * state.quantity);

    const unavailable = state.stockEnforced && state.quantity > state.availableStock;
    submit.disabled = unavailable || state.quantity < 1;
    submit.textContent = unavailable ? 'Not enough stock' : 'Add to basket';
  }

  function openDrawer(trigger) {
    const drawer = getDrawer();
    const isBulk = trigger.dataset.isBulk === 'true';
    const stockEnforced = trigger.dataset.stockEnforced === 'true';
    const availableStock = Math.max(0, Number(trigger.dataset.availableStock || 0));
    const unitPrice = Math.max(0, Number(trigger.dataset.unitPriceCents || 0)) / 100;

    let options = [];
    let selectedIndex = 0;

    if (isBulk) {
      options = parsePackOptions(
        trigger.dataset.packOptions,
        trigger.dataset.packUnit || 'Can'
      );

      if (!options.length) return;

      selectedIndex = options.findIndex((option) => {
        return !stockEnforced || option.quantity <= availableStock;
      });

      if (selectedIndex < 0) selectedIndex = 0;
    }

    activeTrigger = trigger;
    state = {
      variantId: Number(trigger.dataset.variantId),
      title: trigger.dataset.productTitle || '',
      image: trigger.dataset.productImage || '',
      meta: trigger.dataset.productMeta || '',
      url: trigger.dataset.productUrl || '#',
      isBulk,
      options,
      selectedIndex,
      quantity: 1,
      unitPrice,
      stockEnforced,
      availableStock
    };

    drawer.querySelector('[data-vss-quickbuy-title]').textContent = state.title;
    drawer.querySelector('[data-vss-quickbuy-meta]').textContent = state.meta;

    const detailsLink = drawer.querySelector('[data-vss-quickbuy-details]');
    if (detailsLink) detailsLink.href = state.url;

    const image = drawer.querySelector('[data-vss-quickbuy-image]');
    image.src = state.image;
    image.alt = state.title;

    renderPurchaseUI();

    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('vss-quickbuy-open');

    const close = drawer.querySelector('.vss-quickbuy__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-vss-quickbuy]');
    if (!drawer || drawer.hidden) return;

    drawer.classList.remove('is-open');
    document.body.classList.remove('vss-quickbuy-open');

    window.setTimeout(() => {
      drawer.hidden = true;
      if (activeTrigger) activeTrigger.focus();
      activeTrigger = null;
      state = null;
    }, 220);
  }

  function setTriggerState(button, mode) {
    const text = button.querySelector('[data-card-quick-add-text]');
    if (!text) return;

    if (mode === 'loading') {
      button.disabled = true;
      text.textContent = 'Adding…';
    } else if (mode === 'success') {
      button.disabled = false;
      text.textContent = 'Added ✓';
      window.setTimeout(() => {
        text.textContent = button.dataset.isBulk === 'true' ? 'Choose' : 'Add';
      }, 1100);
    } else {
      button.disabled = false;
      text.textContent = button.dataset.isBulk === 'true' ? 'Choose' : 'Add';
    }
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh basket.');
    return response.json();
  }

  function updateCartBubble(itemCount) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (itemCount <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      bubble.appendChild(visible);
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      bubble.appendChild(hidden);
      cartIcon.appendChild(bubble);
    }

    const spans = bubble.querySelectorAll('span');
    if (spans[0]) spans[0].textContent = itemCount < 100 ? String(itemCount) : '';
    if (spans[1]) spans[1].textContent = `${itemCount} items`;
  }

  async function refreshAndOpenCartDrawer() {
    const cart = await getCart();
    updateCartBubble(cart.item_count);

    const notification = document.querySelector('cart-notification');
    const clone = document.querySelector('cart-notification-clone');

    if (
      notification &&
      typeof notification.renderContents === 'function' &&
      clone &&
      typeof clone.showClone === 'function'
    ) {
      let hydratedCart = cart;

      if (typeof notification.addCompareAtPrice === 'function') {
        try {
          hydratedCart = await notification.addCompareAtPrice(cart);
        } catch (error) {
          hydratedCart = cart;
        }
      }

      notification.renderContents(
        hydratedCart.items,
        'no-sections',
        'full-cart',
        false,
        hydratedCart.total_price
      );

      requestAnimationFrame(() => clone.showClone());
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  async function addToCart(variantId, quantity, trigger = null) {
    if (trigger) setTriggerState(trigger, 'loading');

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity }]
      })
    });

    const result = await response.json();

    if (!response.ok) {
      if (trigger) setTriggerState(trigger, 'idle');
      throw new Error(result.description || result.message || 'Unable to add this item.');
    }

    if (trigger) setTriggerState(trigger, 'success');
    await refreshAndOpenCartDrawer();
  }

  document.addEventListener('click', async (event) => {
    const cardButton = event.target.closest('[data-card-quick-add]');
    if (cardButton) {
      event.preventDefault();
      event.stopPropagation();

      if (cardButton.disabled) return;

      openDrawer(cardButton);
      return;
    }

    const option = event.target.closest('[data-vss-quickbuy-option]');
    if (option && state) {
      if (option.disabled || option.getAttribute('aria-disabled') === 'true') return;
      state.selectedIndex = Number(option.dataset.vssQuickbuyOption);
      renderPurchaseUI();
      return;
    }

    const minus = event.target.closest('[data-vss-quickbuy-minus]');
    if (minus && state && !state.isBulk) {
      if (state.quantity > 1) {
        state.quantity -= 1;
        renderPurchaseUI();
      }
      return;
    }

    const plus = event.target.closest('[data-vss-quickbuy-plus]');
    if (plus && state && !state.isBulk) {
      const maxReached = state.stockEnforced && state.quantity >= state.availableStock;
      if (!maxReached) {
        state.quantity += 1;
        renderPurchaseUI();
      }
      return;
    }

    if (event.target.closest('[data-vss-quickbuy-close]')) {
      closeDrawer();
      return;
    }

    const submit = event.target.closest('[data-vss-quickbuy-submit]');
    if (submit && state) {
      const quantity = state.isBulk
        ? state.options[state.selectedIndex].quantity
        : state.quantity;

      if (state.stockEnforced && quantity > state.availableStock) {
        renderPurchaseUI();
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Adding…';

      try {
        await addToCart(state.variantId, quantity, null);
        closeDrawer();
      } catch (error) {
        console.error(error);
        submit.disabled = false;
        submit.textContent = 'Add to basket';
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });
})();
